export default 'Mandataire CEE & primes 2026 | Solution Éco France';
